export default {"src":"/_next/static/media/mb_approval.b41f05e2.svg","height":142,"width":100,"blurWidth":0,"blurHeight":0};